// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Rq-z","breadcrumbForward":"Sq-z","breadcrumbBack":"Tq-z","selected":"Uq-z"};